import isBlobSource from '../isBlobSource'
import isDefaultPreview from '../isDefaultPreview'

const isNewUpload = (src: string) => {
  return isBlobSource(src) || isDefaultPreview(src)
}

export default isNewUpload
